import ActionBar from '../../../../components/ActionBar/NewActionBar';
import Button from '../../../../components/Button/Button';
import Constants from 'expo-constants';
import InfoCard from '../../../../components/InfoCard/InfoCard';
import Loading from '../../../../components/Loading/Loading';
import Show from '../../../../components/Show/Show';
import styled from 'styled-components/native';
import { COLORS } from '../../../../config/designSystem/Colors';
import { FC, useEffect, useState } from 'react';
import { InstantHelpStackParamList } from '../../../../types/navigation';
import { ParagraphLRegular } from '../../../../config/designSystem/typography';
import { assistanceKey, branchingKey, sessionStackKey } from '../../../../constants/routeKeys';
import { concatPath } from '../../../../utils/links/concatPath';
import { isWeb } from '../../../../config/designSystem/Layout';
import { logAmplitude } from '../../../../utils/analytics/analytics';
import { observer } from 'mobx-react';
import { openURL } from 'expo-linking';
import { router, useGlobalSearchParams } from 'expo-router';
import { useRegionInfo } from '../../../../hooks/useRegionInfo';
import { useStores } from '../../../../hooks/useStores';

export const FrameForInstantHelpPhone = styled.View`
  flex: 1;
  justify-content: space-between;
  align-items: center;
  margin-top: ${isWeb ? 0 : Constants.statusBarHeight}px;
  margin-bottom: ${isWeb ? 0 : 32}px;
  margin-horizontal: 16px;
  background-color: ${COLORS.surface.primary};
  opacity: 1;
`;

const Footer = styled.View`
  flex-direction: column;
  align-items: center;
`;

const Instructions = styled.View``;
const Instruction = styled(ParagraphLRegular)<{color?: string}>`
  text-align: center;
  color: ${({color = COLORS.content.primary}) => color};
`;


type InstantHelpPhoneProps = InstantHelpStackParamList['Phone'];

const InstantHelpPhone: FC<InstantHelpPhoneProps> = observer(() => {
  const {freePhoneNumber, dialPhoneNumber } = useRegionInfo();
  const params = useGlobalSearchParams();
  const userIsInRegion = params?.userIsInRegion || false;


  const [phoneNumber, setPhoneNumber] = useState<string>('');

  const rootStore = useStores();
  const { language } = rootStore;
  const labels = language.translate.MOBILE.ASSISTANCE;

  const onPress = () => {
    openURL('tel:' + phoneNumber);
    logAmplitude('Instant Help Phone-App Opened', {
      freephone: userIsInRegion === 'true',
    });
  };

  useEffect(() => {
    setPhoneNumber((( userIsInRegion==='true')? freePhoneNumber : dialPhoneNumber) || '');
  }, [userIsInRegion, dialPhoneNumber, freePhoneNumber]);

  // the instant-help questions play as a block inside their own session:
  // branching only understands a sessionId
  const goToInstantHelpSession = async () => {
    const sessionId = await rootStore.session.fetchSessionIdOfType('instantHelp');
    if (!sessionId) {
      console.warn('No session of type instantHelp');
      return;
    }
    router.navigate({
      pathname: concatPath([sessionStackKey,branchingKey], 3) as string,
      params: {
        sessionId,
        fromPath: encodeURIComponent(false),
        fromReckoning: encodeURIComponent(false),
      }});
  };



  const goToAssistance = () => {
    router.navigate(concatPath([assistanceKey],2));
  };
  return (
    <FrameForInstantHelpPhone>
      <ActionBar
        width='100%'
        height={40}
        title={labels?.INSTANT_HELP?.TITLE}
        onExit={goToAssistance}
        onPrevious={() => { goToInstantHelpSession().catch(console.error); }}
        marginTopPhone={0}
      />
      <Instructions>
        <Instruction>
          {labels?.CALL?.PHONE_INSTRUCTION}
        </Instruction>
        <Show when={phoneNumber.length === 0}>
          <Loading />
        </Show>
        <Instruction color={COLORS.content.accent}>
          {phoneNumber}
        </Instruction>
      </Instructions>
      <Footer>
        <Show when={`${userIsInRegion}` === 'false'}>
          <InfoCard
            info={language?.translate?.MOBILE?.ASSISTANCE?.CALL?.CHARGE_WARNING}
            type='warn'
          />
        </Show>
        <Button
          onPress={onPress}
          label={labels?.CALL?.BUTTON_OPEN_PHONE_APP}
        />
      </Footer>
    </FrameForInstantHelpPhone>
  );
});

export default InstantHelpPhone;

